import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f35bb82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pop-btn rel of-hd" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "pop" }

import { toRef } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  offset: {
    type: String,
    default: '30px'
  },
  duration: {
    type: String,
    default: '.2s'
  },
  always: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props
_useCssVars(_ctx => ({
  "6c776379": (_unref(duration)),
  "5790afb8": (_unref(offset))
}))


const always = toRef(props, 'always')
const offset = always.value ? '0' : toRef(props, 'offset')
const duration = toRef(props, 'duration')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "pop")
    ])
  ]))
}
}

})